import { Separator } from "../ui/separator";

export interface FooterProps {
  className?: string;
  companyName?: string;
  links?: Array<{
    label: string;
    href: string;
  }>;
}

export function Footer({
  companyName = "Project Exodus",
  links = [],
  className,
}: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`border-t bg-background ${className || ""}`}>
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between">
          <p className="text-muted-foreground text-sm">
            © {currentYear} {companyName}. All rights reserved.
          </p>
          {links.length > 0 && (
            <>
              <Separator className="sm:hidden" />
              <nav className="flex flex-wrap justify-center gap-4 sm:gap-6">
                {links.map((link) => (
                  <a
                    className="text-muted-foreground text-sm transition-colors hover:text-foreground"
                    href={link.href}
                    key={link.href}
                  >
                    {link.label}
                  </a>
                ))}
              </nav>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
